import { render, staticRenderFns } from "./GlobalToast.vue?vue&type=template&id=0b54caf4"
import script from "./GlobalToast.vue?vue&type=script&lang=js"
export * from "./GlobalToast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports